export default {
  // Errors
  canNotDeleteBaseCurrency: 'Can not delete base currency',
  canNotDeleteDisplayCurrency: 'Can not display currency',
  canNotDeleteFiscalCurrency: 'Can not delete fiscal currency',
  duplicateId: 'duplicate id',
  notFound: 'Currency not found',

  // Words
  baseCurrency: 'Base currency',
  currencyRemoved: 'Currency removed',
  currencySettingsUpdated: 'Currency settings updated',
  currencyUpdated: 'Currency updated',
  displayCurrency: 'Display currency',
  displayRate: 'Display rate',
  enterBaseCurrency: 'Enter base currency',
  enterDisplayCurrency: 'Enter display currency',
  enterFiscalCurrency: 'Enter fiscal currency',
  fiscalCurrency: 'Fiscal currency',
  newCurrencyAdded: 'New currency added',
  rate: 'Rate',
  symbol: 'Symbol'
}
